export default __webpack_public_path__ + "static/media/forgot-password-success.18a043ce.svg";